// extracted by mini-css-extract-plugin
export default {"maxlength":"ydkSAbYBHEj8-yDyrHsX2","tooltip__icon":"_1ysRae2LiTGo7yHtA9ZC-i"};